// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1V76D","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1Dqav"};